module.exports = __webpack_public_path__ + "img/enjojj_brand_logo.253afb15.png";